import { VelvetCommonContent } from "../../../../modules/content/components/VelvetCommonContent/VelvetCommonContent";
import { VelvetMedia } from "../../../../modules/content/components/VelvetMedia/VelvetMedia";
import { VelvetSection } from "../../../../modules/content/components/VelvetSection/VelvetSection";
import type { IImageBlockProps } from "./ImageBlock.props";

export const ImageBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  image,
  parentClass,
  spacing,
}: IImageBlockProps) => {
  if (!image) return null;

  return (
    <VelvetSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="grid gap-16 lg:grid-cols-12 lg:gap-y-24">
        <VelvetCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
          className="lg:col-span-8"
        />
        <VelvetMedia
          aspectRatio={image.aspectRatio}
          className="velvet-unveil border-y border-parchment/20 lg:col-span-10 lg:col-start-3"
          media={image.image}
          sizes="(min-width: 1280px) 1184px, calc(100vw - 48px)"
        />
      </div>
    </VelvetSection>
  );
};

ImageBlock.displayName = "Block::ImageBlock";
